import { AuthForm } from './AuthForm'

/** `/signin`. Public-only: a signed-in user is sent on. SUAP-0202. */
export function SignIn() {
  return <AuthForm mode="signIn" />
}
